// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1YLeW","title":"BackImages_title__3Y7SW","images":"BackImages_images__YNllV"};